import { Tooltip, TooltipContent, TooltipTrigger } from 'shared-ui';

interface MapNavButtonsProps {
    /** Target coordinate as [longitude, latitude]. */
    coords: [number, number];
}

interface NavLink {
    label: string;
    href: string;
    /** Path to a public image asset for the brand mark. */
    iconSrc: string;
}

/**
 * A row of navigation deep-link buttons (Waze, Google Maps, Apple Maps) that open the
 * given coordinate in the respective maps app in a new tab. Shown at the bottom of the
 * SAVI air-valve detail card.
 */
export function MapNavButtons({ coords }: MapNavButtonsProps) {
    const lng = String(coords[0]);
    const lat = String(coords[1]);

    const links: NavLink[] = [
        { label: 'Open in Waze', href: `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`, iconSrc: '/icon-waze.png' },
        {
            label: 'Open in Google Maps',
            href: `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
            iconSrc: '/icon-google.png',
        },
        { label: 'Open in Apple Maps', href: `https://maps.apple.com/?ll=${lat},${lng}`, iconSrc: '/icon-apple.png' },
    ];

    return (
        <div className="flex items-center gap-[10px]">
            {links.map(({ label, href, iconSrc }) => (
                <Tooltip key={label}>
                    <TooltipTrigger
                        render={
                            <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={label}
                                className="border-border bg-background hover:bg-accent hover:text-accent-foreground focus-visible:ring-origin-blue/50 flex h-10 w-[85px] items-center justify-center rounded-md border transition-colors focus-visible:ring-3 focus-visible:outline-none"
                            >
                                <img
                                    src={iconSrc}
                                    alt=""
                                    aria-hidden="true"
                                    className="max-h-6 max-w-[60px] object-contain"
                                />
                            </a>
                        }
                    />
                    <TooltipContent side="bottom">{label}</TooltipContent>
                </Tooltip>
            ))}
        </div>
    );
}
